import type { Dayjs } from 'dayjs'
import cx from 'classnames'
import styles from '../Calendar.module.scss'
import { getCalendarDays, getEventTimes, getCalendarDayClasses } from '../utils'
import { DATE_FORMAT } from '~constants'
import { ArtistProps } from '../types'
import { EventInfo } from './EventInfo'
import dayjs from 'dayjs'
import { NO_SHOW_TODAY } from '../constants'
import { EventsByDate, FormattedEvent } from '../types/Event'

const CalendarTabletView = ({
  month,
  eventsByDate,
  artists,
  handleDateSelection
}: {
  month: Dayjs
  eventsByDate: EventsByDate
  artists: ArtistProps[]
  handleDateSelection: (event: FormattedEvent[], artist: ArtistProps) => void
}) => {
  const today = dayjs()
  const startDate = month.startOf('month').isBefore(today) ? today.clone() : month.startOf('month')
  const endDate = month.endOf('month')

  // Calculate the end date of the calendar view
  const monthEndDay = endDate.day()
  let calendarEndDate
  if (monthEndDay === 0 || monthEndDay === 1 || monthEndDay === 2) {
    calendarEndDate = endDate.endOf('week')
  } else {
    calendarEndDate = endDate.add(1, 'week').endOf('week')
  }

  const weeks = getCalendarDays(startDate, startDate, endDate, eventsByDate)

  return (
    <>
      <div className={styles['calendar__month']}>
        <div className={styles['calendar__month-wrapper']}>
          {weeks.map((week, _) => {
            return (
              <>
                {week.map(eventInfo => {
                  const day = eventInfo.date
                  const formattedDate = day?.format(DATE_FORMAT.SHORT_DATE_FORMAT)
                  const formattedDay = day.format(DATE_FORMAT.SHORT_DAY)
                  const dayNumber = day.format(DATE_FORMAT.SHORT_DATE)
                  let uniqueArtists = eventInfo?.events?.filter(
                    (value, index, self) => index === self.findIndex(t => t.artistId === value.artistId)
                  )
                  return (
                    <div
                      key={`${formattedDate}`}
                      className={cx(
                        getCalendarDayClasses(eventInfo)
                          .split(' ')
                          .map(cls => styles[cls])
                      )}
                    >
                      <div className={styles['calendar__day-header']}>
                        <div className={styles['grid-day']}>{formattedDay}</div>
                        <div className={styles['grid-date']}>{dayNumber}</div>
                      </div>
                      <div className={styles['calendar__day-wrapper']}>
                        {uniqueArtists?.map((event, index) => {
                          return (
                            <EventInfo
                              handleDateSelection={handleDateSelection}
                              event={eventInfo.events}
                              artist={artists.find((item: ArtistProps) => item.artistId == event?.artistId) as Artist}
                              key={event?.artistId || index}
                              eventsTime={getEventTimes(eventInfo.events, event?.artistId)}
                            />
                          )
                        })}
                        {eventInfo?.events?.length == 0 && (
                          <div className={styles['calendar__no-events']}>
                            <span>{NO_SHOW_TODAY}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </>
            )
          })}
        </div>
      </div>
    </>
  )
}

export default CalendarTabletView
